import { render } from "./CustomerLoginView.vue?vue&type=template&id=6942815d"
import script from "./CustomerLoginView.vue?vue&type=script&lang=js"
export * from "./CustomerLoginView.vue?vue&type=script&lang=js"

import "./CustomerLoginView.vue?vue&type=style&index=0&id=6942815d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__